import { observer } from 'mobx-react-lite'
import { useEffect, useState, type CSSProperties } from 'react'

import { restClient } from '@/Core'
import { formatAppDate } from '@/Ship/Helpers/appTime'
import { cx } from '@/Ship/Helpers/cssClass'

import { DELAY_STATUS_COLORS, DELAY_STATUS_LABELS } from './Constants'
import { DelaysSectionStore } from './DelaysSectionStore'

import styles from './Drawer.module.css'

import type { DelayItem } from './Types'

interface DelaysSectionProps {
    assignmentUuid: string
    refreshKey: number
}

/** Затримки завдання: статус, час, коментар водія, відповідь диспетчера */
export const DelaysSection = observer(({ assignmentUuid, refreshKey }: DelaysSectionProps) => {
    const [store] = useState(() => new DelaysSectionStore())

    useEffect(() => {
        if (!assignmentUuid) return
        store.setLoading(true)
        restClient
            .get(`/services/executor-assignments/${assignmentUuid}/delays`)
            ?.then((data: any) => store.setDelays((data?.items ?? []) as DelayItem[]))
            ?.catch(() => store.setDelays([]))
            ?.finally(() => store.setLoading(false))
    }, [assignmentUuid, refreshKey])

    if (store.loading) return <span className="pwa-muted">Завантаження…</span>
    if (store.delays.length === 0) return <span className="pwa-muted">Затримок не було</span>

    return (
        <>
            {store.delays.map((delay) => {
                const color = DELAY_STATUS_COLORS[delay.status] || '#8c8c8c'
                return (
                    <div key={delay.uuid} className={cx(styles, 'delay')}>
                        <div className={cx(styles, 'delayHead')}>
                            <span className="pwa-status" style={{ '--status': color } as CSSProperties}>
                                {DELAY_STATUS_LABELS[delay.status] || delay.status}
                            </span>
                            <span className={cx(styles, 'delayTime')}>
                                {formatAppDate(delay.receivedAt, 'DD.MM, HH:mm') ?? '—'}
                            </span>
                        </div>
                        <div className={cx(styles, 'delayText')}>{delay.driverComment}</div>
                        {delay.resolverComment && (
                            <div className={cx(styles, 'delayResolver')}>Диспетчер: {delay.resolverComment}</div>
                        )}
                        {delay.resolvedAt && (
                            <div className={cx(styles, 'delayTime')}>
                                Вирішено {formatAppDate(delay.resolvedAt, 'DD.MM, HH:mm')}
                            </div>
                        )}
                    </div>
                )
            })}
        </>
    )
})
